import { Component } from '@opten/compiler/metadata/component';
import { tabs } from './tabs';

@Component({ className: 'js-tabs', observe: true })
export class TabsComponent {	
    constructor(private element: HTMLElement) {
        tabs(element);
    }
}